<template>
<div>

	<div v-if="expandedStyle" class="multi-select-expanded-style">
		<ul v-if="expandedList.length > 0" class="expanded-list">
			<li v-for="(item,index) in expandedList" class="selected-item">
				<span>{{item.text}}</span>
				<i class="fa fa-times remove-item icon-button" v-on:click="removeItem(item,index)"></i>
			</li>
		</ul>
	</div>

	<multiselect v-if="!readonly && !grouped"
    	:options="mutatedOptions" 
    	v-model="boundValue" 
    	v-on:input="updateValue" 
    	v-on:open="$emit('open')"
    	v-on:close="closeList"
    	v-on:search-change="$emit('searchChange',$event)"
    	:multiple="multiple && !expandedStyle" 
    	:placeholder="placeholder"
    	:close-on-select="closeOnSelect"
    	:clear-on-select="true"
    	:searchable="!disableSearch"
    	label="text"
    	track-by="value"
    	name=""
    	:loading="loading"
    	:name="randomNameProp"
    	:autocomplete="Math.random()"
    	:show-labels="false">
    </multiselect>
    <multiselect v-else-if="!readonly && grouped"
    	:options="mutatedOptions" 
    	group-label="groupLabel"
    	group-values="groupValues"
    	:group-select="false"
    	v-model="boundValue" 
    	v-on:input="updateValue" 
    	v-on:close="closeList"
    	v-on:open="$emit('open')"
    	v-on:search-change="$emit('searchChange',$event)"
    	:multiple="multiple && !expandedStyle" 
    	:placeholder="placeholder"
    	label="text"
    	:close-on-select="closeOnSelect"
    	:clear-on-select="true"
    	:searchable="!disableSearch"
    	track-by="value"
    	:loading="loading"
    	:name="randomNameProp"
    	:autocomplete="Math.random()"
    	:show-labels="false">
    </multiselect>
    <input v-else-if="!expandedStyle"
    	type="text"
    	class="form-control-plaintext" 
    	readonly 
    	:name="Math.random()"
    	:value="boundValue">

</div>
</template>

<script type="text/javascript">
/*
This is a wrapper for vue-multiselect. vue-multiselect requires an array of objects to be passed in as options, and binding io's an object. This wrapper converts the binding to a primitive array so the multi-select performs more like a native HTML <select multiple> element
*/

import Multiselect from 'vue-multiselect'

	export default {
		name: "MultiSelect",
		props: [
			"options", //an array of objects with value, text properties
			"value", //value of field,
			"multiple",
			"readonly",
			"grouped",
			"closeOnSelect",
			"expandedStyle",
			"placeholder",
			"loading",
			"disableSearch"
		],
		data() {
			return {
				boundValue: [], //array of objects,
				expandedList: []
			}
		},
		components: {
			Multiselect
		},
		watch: {
			value() {
				this.mutateValue()
			},
			options() {
				this.mutateValue()
			}
		},
		computed: {
			randomNameProp() {
				let rand = Math.random()

				return rand.toString()
			},
			mutatedOptions() {
				let vm = this

				let mutated = this.options.map(option => {
					if (typeof option == "string") {
						return {
							value: option,
							text: option
						}
					}
					
					if ("disabled" in option)
						option.$isDisabled = option.disabled

					return option
				})

				return mutated

				/*if (this.expandedStyle) {
					return mutated.filter(option => {
						if (vm.expandedList.find(opt => opt.value == option.value))
							return false
						else
							return true
					})
				}
				else return mutated*/
			}
		},
		methods: {
			removeItem(item,index) {
				this.expandedList.splice(index,1)

				let valueArray = this.expandedList.map(item => {
					return item.value
				})

				this.$emit("input",valueArray)
				this.$emit("change",valueArray)
			},
			closeList() {
				this.$emit("close")
			},
			mutateValue() {

				if (this.multiple) {
					//PRIMITIVE ARRAY --> OBJ ARRAY

					//take primitive array of values, and convert them into full objects to pass to the vue-multiselect

					let mutatedValue = []
					let vm = this

					//if value is a string, parse it as json
					let value = this.value
					if (typeof this.value == 'string')
						value = JSON.parse(value)

					if (this.grouped) {
						this.mutatedOptions.forEach(group => {
							group.groupValues.forEach(opt => {
								if (opt.value == vm.value) 
									mutatedValue.push(opt)
							})
						})
					}
					else {
						this.mutatedOptions.forEach(function(opt, index){
							if (typeof value == 'object') {
								value.forEach(function(val) {
									if (opt.value == val)
										mutatedValue.push(opt)
								})
							}
						})
					}

					if (this.readonly) {
						//convert to a comma separated list
						let list = "";

						mutatedValue.forEach(function(val, index) {
							list += val.text
							if (index < mutatedValue.length - 1)
								list += ", "
						})

						this.boundValue = list
					}
					else 
						this.boundValue = mutatedValue

				}
				else {
					//take primitive value, and convert to full object to pass to vue-multiselect
					
					let mutatedValue = {}
					let vm = this

					if (this.grouped) {
						this.mutatedOptions.forEach(group => {
							group.groupValues.forEach(opt => {
								if (opt.value == vm.value) 
									mutatedValue = opt
							})
						})
					}
					else {

						this.mutatedOptions.forEach(function(opt, index){
							if (opt.value == vm.value) 
								mutatedValue = opt
						
						})
					}

					if (this.readonly) {

						//convert to a string
						this.boundValue = mutatedValue.text
					}
					else {
						this.boundValue = mutatedValue
					}
				}
			},
			updateValue(value) {
				//OBJ ARRAY --> PRIMITIVE ARAY
				//mutate the object to just emit a primitive array of values
				let vm = this

				if (this.multiple) {
					let valueArray = []

					if (value instanceof Array) {

						valueArray = value.map(item => {
							return item.value
						})

					}
					else if (value && "value" in value){
						valueArray.push(value.value)
					
						//make sure this is not already in the list before we push the new item
						let found = vm.expandedList.find(item => item.value == value.value)

						if (!found) 
							vm.expandedList.push(value)

						if (this.expandedStyle) 
							valueArray = vm.expandedList.map(item => item.value)

					}

					this.$emit("input",valueArray)
					this.$emit("change",valueArray)
					
				}
				else {

					if (value) {
						this.$emit("input",value.value)
						this.$emit("change",value.value)
					}
					else {
						this.$emit("input",null)
						this.$emit("change",null)
					}
				}


			}
		},
		mounted() {
			this.mutateValue()
		}
	}
</script>

<style type="text/css">
	.multiselect__tags {
		min-height: 38px;
	}

	.multiselect__tag,
	.multiselect__option--highlight {
		background-color: var(--brand-primary-color);
	}

	.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
		background-color: var(--brand-primary-color-faded);
	}

	.multiselect__tag-icon:focus:after, .multiselect__tag-icon:hover:after {
		color: black;
	}

	.multiselect__content-wrapper {
		position: static;
	}

	.multi-select-expanded-style .selected-item {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		background-color: #e0e0e0;
		margin-bottom: 2px;
		border-radius: 2px;
		padding: 2px;
		padding-left: 5px;
		padding-right: 5px;

		background-color: #fff;
		padding: 5px;
		border: 1px solid rgba(0,0,0,0.125);
		margin-bottom: -1px;
	}

	.multi-select-expanded-style .selected-item .remove-item:hover {
		cursor: pointer;
		opacity: 0.8;
	}

	.multi-select-expanded-style .selected-item:first-child {
		border-top-left-radius: .25rem;
		border-top-right-radius: .25rem;
	}

	.multi-select-expanded-style .selected-item:last-child {
		border-bottom-left-radius: .25rem;
		border-bottom-right-radius: .25rem;
	}

	.multi-select-expanded-style .expanded-list {
		padding: 0;
		margin: 0;
		margin-bottom: 5px;
	}

</style>